import { formatCurrency } from "@solomon-apps/shared";
import { BigDecimal } from "@solomon-labs/bigdecimal";

import type { ReportingBacking, ReportingEnvelope, ReportingToken } from "./useJachinReporting";
import type { ReserveClassRow } from "./useReservesData";

export function reportingReserveClasses(backing: ReportingBacking | null | undefined): ReserveClassRow[] {
    if (!backing?.asOf) return [];
    const priced = backing.holdings.filter((h) => h.amountUsd !== null && new BigDecimal(h.amountUsd).gt(0));
    const total = priced.reduce((sum, h) => sum.add(h.amountUsd ?? "0"), new BigDecimal(0));
    if (!total.gt(0)) return [];
    return [
        {
            label: "Stablecoins",
            amount: total.toNumber(),
            amountDisplay: formatCurrency(total.toString()),
            share: "100%",
            assets: priced.map((h) => ({
                symbol: h.symbol,
                amount: new BigDecimal(h.amountUsd ?? "0").toNumber(),
                amountDisplay: formatCurrency(h.amountUsd ?? "0"),
                share: `${new BigDecimal(h.amountUsd ?? "0").divide(total).multiply(100).round(2).toFixed(2)}%`,
                venues: [
                    {
                        label: "Reserve vault",
                        amount: new BigDecimal(h.amountUsd ?? "0").toNumber(),
                        amountDisplay: formatCurrency(h.amountUsd ?? "0"),
                        verifyAddress: h.vaultAddress ?? undefined
                    }
                ]
            }))
        }
    ];
}
export function reportingCoverage(
    token: ReportingEnvelope<ReportingToken> | undefined,
    backing: ReportingEnvelope<ReportingBacking> | undefined
): string {
    if (
        token?.status !== "available" ||
        backing?.status !== "available" ||
        !token.data ||
        backing.data?.totalUsd === undefined ||
        backing.data.totalUsd === null ||
        !token.fetchedAt ||
        !backing.sourceAt ||
        Math.abs(Date.parse(token.fetchedAt) - Date.parse(backing.sourceAt)) > 300_000
    )
        return "—";
    const supply = new BigDecimal(token.data.totalSupplyUi);
    return supply.gt(0)
        ? `${new BigDecimal(backing.data.totalUsd).divide(supply).multiply(100).round(0).toFixed(0)}%`
        : "—";
}
